(function () {
    'use strict';

    angular
        .module('blocks.auth')
        .factory('authDataService', authDataService);

    authDataService.$inject = ['$http', '$q', 'exception', 'logger'];
    /* @ngInject */
    function authDataService($http, $q, exception, logger) {
        var service = {
            login: login,
            logout: logout,
            saveUserConfigOptions: saveUserConfigOptions,
            acceptTerms: acceptTerms,
            getFilters: getFilters,
            getCurrentUser: getCurrentUser,
            getAccessToken: getAccessToken,
            getFilterData: getFilterData,
            checkIsAdmin: checkIsAdmin
        };

        return service;

        function getFilters(userId) {
            return $http.get('api/FilterTypes/ForUser/' + userId);
        }

        function getFilterData(filterTypeId) {
            return $http.get('api/Users/FilterData/' + filterTypeId);
        }

        function getCurrentUser() {
            return $http.get('api/Users/Current');
        }

        function checkIsAdmin() {
            return $http.get('api/Users/IsCurrentUserAdmin');
        }


        function logout() {
            return $http.post('api/Account/logout');
        }

        function acceptTerms() {
            return $http.post('api/Users/AcceptTerms', {});
        }

        function saveUserConfigOptions(data) {
            return $http.post('api/Users/SetConfigOptions', data).catch(fail);


            function fail(e) {
                return exception.catcher('Login Failed')();
            }

        }

        function getAccessToken(tempKey) {
            return $http.get('api/Account/LocalToken?externalAccessToken=' + tempKey.external_access_token);
        }

        function login(data) {
            var config = {
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                transformRequest: function (obj) {
                    var str = [];
                    for (var p in obj) {
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    }
                    return str.join("&");
                }
            };
            return $http.post('Token', data, config).catch(fail);

            function success(response) {
                logger.info("Login Successful")
                return response;
            }

            function fail(e) {
               
                return exception.catcher('Login Failed')(e);
            }

        }
    }
})();
